export function RadioDot({ checked }: { checked: boolean }) {
  return (
    <div
      className={`w-5 h-5 rounded-full border flex items-center justify-center ${
        checked ? "border-[#202020] bg-[#202020]" : "border-[rgba(0,0,0,0.15)]"
      } `}
    >
      {checked && <div className="w-2 h-2 rounded-full bg-white" />}
    </div>
  );
}
